import { Alert, Button, Link } from "@mui/material";
import { useTranslation } from "react-i18next";

export const GeneralError = () => {
  const { t } = useTranslation();

  return (
    <>
      <Alert severity="error">{t("common.generalError")}</Alert>
      <Button variant="contained" component={Link} sx={{ mt: 2 }} href="/">
        {t("common.goToHome")}
      </Button>
    </>
  );
};
